import * as yup from "yup";
import moment from "moment";
import autoGenerateUsername from "config.json";
const model = {
  vendorName: "",
  vendorShortCode: "",
  regDate: new Date(),
  status: "",
  desc: "",
};

const validationModel = yup.object().shape({
  vendorName: yup.string().required("Please enter vendor name"),
  vendorShortCode: yup.string().required("Please enter vendor short code"),
  regDate: yup.string().required("Please enter reg date"),
  status: yup.string().required("Please enter status"),
  desc: yup.string().required("Please enter desc"),
});

const StatusList = [
  { value: "Active", label: "Active" },
  { value: "Inactive", label: "Inactive" },
];

const countries = ["India"];
export { model, validationModel, countries, StatusList };
